<template>
    <div :class="'endpoint-warning endpoint-warning-' + type">
        <icon name="warning" class="warning-icon"/>
        <span class="warning-text">
                        This endpoint is not intended for public usage and might be changed or removed at any time.
                    </span>
    </div>
</template>

<script>
  import Icon from '../Layout/Icon';

  export default {
    name:       'EndpointWarning',
    components: { Icon },
    props:      {
      type: {
        type:    String,
        default: 'other',
      },

      message: {
        type:     String,
        required: true,
      },
    },

  };
</script>

<style scoped>
    .endpoint-warning {
        display:     flex;
        flex-wrap:   wrap;
        align-items: center;
        padding:     1rem 0;
    }

    .warning-icon {
        margin-right: 0.5rem;
        color:        var(--color-orange);
    }

    .warning-text {
        color: var(--color-gray-medium);
    }
</style>
